import _assets_host from './_assets_host'

export default function assets_host(assets_host) {
    return _assets_host;
}
